import { CollaboratorState } from './state';

export const collaboratorInitialState: CollaboratorState = {
  assets: {},
  updateStatus: 'initial'
}